<div class="userDisplay" *ngFor="let userRecord of displayUsersParameters.userRecords; let j = index">
    {{userRecord.playerName}}
</div>
<div class="userDisplay" *ngIf="displayUsersParameters.userCount > displayUsersParameters.userRecords.length">
    + {{displayUsersParameters.userCount - displayUsersParameters.userRecords.length}} more
</div>